
import { defineComponent } from "vue";
import router from "@/router";
import OwnerService from "@/services/OwnerService";
const ownerService = new OwnerService();

import { TERMS_CONDITIONS_URL, PRIVACY_POLICY_URL } from "@/const";

export default defineComponent({
  name: "Signup",
  props: {},
  setup(props) {
    console.log("coucou", props);
  },
  methods: {
    // TODO FIRST
    // put in service
    //display error message on view
    async signup() {
      this.errorMessage = "";
      this.isCreating = true;
      console.log("try to signup", this.termsCondition);
      if (this.password == "" || this.email == "" || !this.termsCondition) {
        this.errorMessage = this.$t("signup.fieldsMandatory");
        this.isCreating = false;
        return false;
      }
      if (this.password.length < 8) {
        this.errorMessage = this.$t("signup.passwordShort");
        console.log("pwd too short");
        this.isCreating = false;
        return false;
      }
      const creationAnswder = await ownerService.signupOwner(
        this.email,
        this.password
      );
      console.log("connectionAnswer", creationAnswder);
      if (creationAnswder.success) {
        // alert(this.$t("signup.accountCreated"));
        this.isSuccess = true;
        // window.location.reload();
      } else {
        this.isCreating = false;
        this.errorMessage = creationAnswder.message;
      }
    },
  },
  data() {
    return {
      email: "",
      password: "",
      termsCondition: false,
      errorMessage: "",
      isCreating: false,
      isSuccess: false,
      TERMS_CONDITIONS_URL: TERMS_CONDITIONS_URL,
      PRIVACY_POLICY_URL: PRIVACY_POLICY_URL,
    };
  },
});
